import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider
} from "@mui/material/";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import actions from "../../../../Store/actions";
import { strings } from "../../../../common/i18n";
import { logToSentry } from "../../../../config/Sentry";

const AbandonAuditButton = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { audits } = useSelector((state) => state);
    const auditId = audits?.item?.id;

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        if (!auditId) return;
        setLoading(true);
        try {
            await dispatch(
                actions.audits.create.bulkAbandonedCloseRequest([auditId])
            );
            dispatch(
                actions.toast.create.success(strings("messages.auditAbandoned"))
            );
            setLoading(false);
            setOpen(false);
            const auditPath = pathname.split("/").slice(0, -1).join("/");
            navigate(`${auditPath}/inprogress`, { replace: true });
        } catch (error) {
            logToSentry("On abandon audit:", { error });
            dispatch(
                actions.toast.create.error(strings("errors.onAbandonAudit"))
            );
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => setOpen(true)}
                sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    whiteSpace: "nowrap"
                }}
                startIcon={
                    <BlockOutlinedIcon sx={{ fontSize: "16px !important" }} />
                }
            >
                {strings("abandonAudit")}
            </Button>

            <Dialog open={open} onClose={() => !loading && setOpen(false)}>
                <DialogTitle>{strings("abandonAudit")}</DialogTitle>
                <Divider />
                <DialogContent>
                    <DialogContentText>
                        {strings("messages.abandonAuditConfirm")}
                    </DialogContentText>
                    <DialogContentText sx={{ mt: 1 }}>
                        {strings("messages.abandonAuditWarning")}
                    </DialogContentText>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleConfirm}
                        disabled={loading}
                        startIcon={
                            loading ? (
                                <CircularProgress size={14} color="inherit" />
                            ) : null
                        }
                    >
                        {loading
                            ? strings("abandoning")
                            : strings("confirmAbandon")}
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setOpen(false)}
                        disabled={loading}
                    >
                        {strings("cancel")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AbandonAuditButton;
